import React from 'react';
import './style.scss';

// Base dos banners desenhados no Figma (frame de 1700x510): o conteúdo escala junto com a largura
// do carrossel, mantendo texto e imagens nítidos em qualquer resolução.
const BannerEscalavel = ({ className = '', children }) => (
  <div className={`banner-escalavel ${className}`}>
    <div className="banner-escalavel-palco">{children}</div>
  </div>
);

export default BannerEscalavel;
